import numeral from 'numeral';

/**
 * @memberof module:util
 * @function
 * @name formatPrice
 * @description It format the price with two decimal points.
 *
 * @param {string | number} price - price to be formatted
 * @returns {number}
 *
 * @example
 * console.log(formatPrice(12.569)); //12.57
 * console.log(formatPrice(12.563)); //12.56
 * console.log(formatPrice("02")); //2.00
 *
 * console.log(formatPrice(null)); //0.00
 */

export const formatPrice = (price) => {
  price = numeral(price).format('0.00');
  return price;
};
